(function () {
  'use strict';

  var N8N_WEBHOOK_URL = 'https://moldarte-n8n.f5puiw.easypanel.host/webhook/65a6ccfe-6f52-4d0c-a739-9ae32d10dc7a';
  var URL_REGEX = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_ALLOWED_CHARS_REGEX = /^\+?[0-9()\s-]+$/;
  var PHONE_EXTENSION_REGEX = /(?:ext\.?|int\.?|interno)\s*\d+$/i;
  var PHONE_MIN_DIGITS = 8;
  var PHONE_MAX_DIGITS = 15;
  var MIN_TEXTAREA_LENGTH = 8;
  var STICKY_HEADER_SELECTORS = [
    '[data-sticky-header]',
    '.shopify-section-header-sticky',
    '.shopify-section-header',
    'header.site-header',
    '.site-header',
    '#shopify-section-header'
  ];

  function initMoldarteCommercialWidget(container) {
    if (!container || container.dataset.moldarteCommercialInitialized === 'true') return;

    var form = container.querySelector('[data-moldarte-commercial-form]');
    if (!form) return;

    var status = container.querySelector('[data-moldarte-commercial-status]');
    var submitButton = form.querySelector('[type="submit"]');
    var typeField = form.querySelector('[data-commercial-switch]');
    var fieldWraps = Array.prototype.slice.call(form.querySelectorAll('[data-commercial-field]'));
    var fields = fieldWraps
      .map(function (fieldWrap) {
        return fieldWrap.querySelector('input, select, textarea');
      })
      .filter(Boolean);
    var conditionalPanels = Array.prototype.slice.call(form.querySelectorAll('[data-commercial-panel]'));

    function getTrimmedValue(input) {
      return input && input.value ? input.value.replace(/^\s+|\s+$/g, '') : '';
    }

    function getStickyOffset() {
      return STICKY_HEADER_SELECTORS.reduce(function (largestHeight, selector) {
        var node = document.querySelector(selector);
        if (!node) return largestHeight;

        var computedStyle = window.getComputedStyle(node);
        var isSticky = computedStyle.position === 'sticky' || computedStyle.position === 'fixed';
        if (!isSticky) return largestHeight;

        return Math.max(largestHeight, node.getBoundingClientRect().height);
      }, 0);
    }

    function getScrollParent(node) {
      var current = node && node.parentElement;

      while (current && current !== document.body) {
        var style = window.getComputedStyle(current);
        var overflowY = style.overflowY;
        var isScrollable = /(auto|scroll|overlay)/.test(overflowY) && current.scrollHeight > current.clientHeight;
        if (isScrollable) return current;
        current = current.parentElement;
      }

      return window;
    }

    function scrollIntoViewIfNeeded(target) {
      if (!target || typeof target.getBoundingClientRect !== 'function') return;

      window.requestAnimationFrame(function () {
        var scrollParent = getScrollParent(target);
        var stickyOffset = getStickyOffset() + 16;
        var rect = target.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        if (scrollParent === window) {
          var topLimit = stickyOffset;
          var bottomLimit = viewportHeight - 16;
          var isVisible = rect.top >= topLimit && rect.bottom <= bottomLimit;

          if (!isVisible) {
            var windowTarget = window.pageYOffset + rect.top - stickyOffset;
            window.scrollTo({ top: Math.max(windowTarget, 0), behavior: 'smooth' });
          }

          return;
        }

        var parentRect = scrollParent.getBoundingClientRect();
        var parentTopLimit = parentRect.top + 12;
        var parentBottomLimit = parentRect.bottom - 12;
        var isInsideParent = rect.top >= parentTopLimit && rect.bottom <= parentBottomLimit;

        if (!isInsideParent) {
          var nextScrollTop = scrollParent.scrollTop + (rect.top - parentRect.top) - 12;
          scrollParent.scrollTo({ top: Math.max(nextScrollTop, 0), behavior: 'smooth' });
        }
      });
    }

    function setStatus(type, message) {
      if (!status) return;
      status.className = 'moldarte-commercial__status is-visible moldarte-commercial__status--' + type;
      status.textContent = message;
      scrollIntoViewIfNeeded(status);
    }

    function clearStatus() {
      if (!status) return;
      status.className = 'moldarte-commercial__status';
      status.textContent = '';
    }

    function getFieldWrap(input) {
      return input ? input.closest('[data-commercial-field]') : null;
    }

    function ensureErrorNode(input, field) {
      var errorNode = field ? field.querySelector('[data-commercial-error]') : null;
      if (!errorNode) return null;

      if (!errorNode.id) {
        errorNode.id = (input.id || input.name || 'moldarte-commercial-field') + '-error';
      }

      errorNode.setAttribute('aria-live', 'polite');
      return errorNode;
    }

    function setFieldDescribedBy(input, errorNode, helperNode) {
      var describedBy = [];
      if (helperNode && helperNode.id) describedBy.push(helperNode.id);
      if (errorNode && errorNode.textContent) describedBy.push(errorNode.id);

      if (describedBy.length) {
        input.setAttribute('aria-describedby', describedBy.join(' '));
      } else {
        input.removeAttribute('aria-describedby');
      }
    }

    function setFieldError(input, message) {
      var field = getFieldWrap(input);
      if (!field) return;

      var errorNode = ensureErrorNode(input, field);
      var helperNode = field.querySelector('.moldarte-commercial__helper');

      field.classList.add('has-error');
      input.setAttribute('aria-invalid', 'true');

      if (errorNode) {
        errorNode.textContent = message;
        setFieldDescribedBy(input, errorNode, helperNode);
      }
    }

    function clearFieldError(input) {
      var field = getFieldWrap(input);
      if (!field) return;

      var errorNode = ensureErrorNode(input, field);
      var helperNode = field.querySelector('.moldarte-commercial__helper');

      field.classList.remove('has-error');
      input.removeAttribute('aria-invalid');

      if (errorNode) {
        errorNode.textContent = '';
      }

      setFieldDescribedBy(input, errorNode, helperNode);
    }

    function getPhoneValidationMessage(value) {
      var normalizedValue = value.replace(PHONE_EXTENSION_REGEX, '').replace(/^\s+|\s+$/g, '');
      var digitsOnly = normalizedValue.replace(/\D/g, '');

      if (!PHONE_ALLOWED_CHARS_REGEX.test(normalizedValue)) {
        return 'Ingresá un celular válido. Podés usar números, espacios, paréntesis, + o guiones.';
      }

      if (digitsOnly.length < PHONE_MIN_DIGITS) {
        return 'Ingresá un celular válido con al menos ' + PHONE_MIN_DIGITS + ' números.';
      }

      if (digitsOnly.length > PHONE_MAX_DIGITS) {
        return 'Ingresá un celular válido con no más de ' + PHONE_MAX_DIGITS + ' números.';
      }

      if (/^0+$/.test(digitsOnly)) {
        return 'Ingresá un celular válido.';
      }

      return '';
    }

    function getActivePanelKey() {
      return typeField ? typeField.value : '';
    }

    function getFieldPanel(input) {
      return input ? input.closest('[data-commercial-panel]') : null;
    }

    function isFieldRelevant(input) {
      if (!input) return false;

      var panel = getFieldPanel(input);
      if (panel && panel.hidden) return false;

      var requiredFor = input.getAttribute('data-commercial-required');
      if (!requiredFor) return true;
      return requiredFor === getActivePanelKey();
    }

    function syncConditionalFieldState() {
      fields.forEach(function (input) {
        var panel = getFieldPanel(input);
        var conditionalKey = input.getAttribute('data-commercial-required');
        var initiallyRequired = input.getAttribute('data-base-required') === 'true';
        var isPanelActive = !panel || !panel.hidden;

        if (!isPanelActive) {
          input.setAttribute('disabled', 'disabled');
          input.removeAttribute('required');
          clearFieldError(input);
          return;
        }

        input.removeAttribute('disabled');

        if (conditionalKey) {
          if (conditionalKey === getActivePanelKey()) {
            input.setAttribute('required', 'required');
          } else {
            input.removeAttribute('required');
            clearFieldError(input);
          }
          return;
        }

        if (initiallyRequired) {
          input.setAttribute('required', 'required');
        }
      });
    }

    function togglePanels() {
      var activeKey = getActivePanelKey();

      conditionalPanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-commercial-panel') === activeKey;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      syncConditionalFieldState();
    }

    function validateField(input) {
      if (!input || input.disabled || !isFieldRelevant(input)) {
        if (input) clearFieldError(input);
        return true;
      }

      var value = getTrimmedValue(input);
      var label = input.getAttribute('data-label') || 'Este campo';
      var isRequired = input.hasAttribute('required');
      var type = input.getAttribute('data-validate') || input.getAttribute('type') || input.tagName.toLowerCase();
      var validity = input.validity || {};

      clearFieldError(input);

      if (isRequired && !value) {
        setFieldError(input, label + ' es obligatorio.');
        return false;
      }

      if (!value) return true;

      if (type === 'email' && (validity.typeMismatch || !EMAIL_REGEX.test(value))) {
        setFieldError(input, 'Ingresá un email válido, por ejemplo nombre@correo.com.');
        return false;
      }

      if (type === 'phone') {
        var phoneMessage = getPhoneValidationMessage(value);
        if (phoneMessage) {
          setFieldError(input, phoneMessage);
          return false;
        }
      }

      if (type === 'url' && !URL_REGEX.test(value)) {
        setFieldError(input, 'Ingresá un link válido, por ejemplo https://ejemplo.com.');
        return false;
      }

      if (input.tagName.toLowerCase() === 'textarea' && isRequired && value.length < MIN_TEXTAREA_LENGTH) {
        setFieldError(input, 'Sumá un poco más de contexto así podemos entender mejor la consulta.');
        return false;
      }

      return true;
    }

    function validateForm() {
      var isValid = true;

      fields.forEach(function (field) {
        if (!validateField(field)) isValid = false;
      });

      return isValid;
    }

    function getFieldValueByName(name, panelKey) {
      var field = form.elements[name];
      if (!field) return '';
      if (panelKey && panelKey !== getActivePanelKey()) return '';
      return getTrimmedValue(field);
    }

    function getSelectValueByName(name, panelKey) {
      var field = form.elements[name];
      if (!field) return '';
      if (panelKey && panelKey !== getActivePanelKey()) return '';
      return field.value || '';
    }

    function buildPayload() {
      return {
        nombre_completo: getTrimmedValue(form.elements.full_name),
        empresa_marca: getTrimmedValue(form.elements.company),
        email: getTrimmedValue(form.elements.email),
        celular_whatsapp: getTrimmedValue(form.elements.phone),
        pais: getTrimmedValue(form.elements.country),
        tipo_de_consulta: typeField ? typeField.options[typeField.selectedIndex].text : '',
        resumen_consulta: getTrimmedValue(form.elements.summary),
        ofrecer_productos: {
          tipo_de_producto: getFieldValueByName('offer_product_type', 'offer_products'),
          descripcion_del_producto: getFieldValueByName('offer_description', 'offer_products'),
          categoria: getFieldValueByName('offer_category', 'offer_products'),
          catalogo_tienda_redes: getFieldValueByName('offer_catalog_link', 'offer_products'),
          precio_mayorista_estimado: getFieldValueByName('offer_wholesale_price', 'offer_products'),
          moq_compra_minima: getFieldValueByName('offer_moq', 'offer_products'),
          stock_disponible: getFieldValueByName('offer_stock', 'offer_products'),
          ubicacion: getFieldValueByName('offer_location', 'offer_products'),
          link_adicional: getFieldValueByName('offer_extra_link', 'offer_products')
        },
        proveedor_fabricante: {
          rol: getSelectValueByName('supplier_role', 'supplier_manufacturer'),
          productos: getFieldValueByName('supplier_products', 'supplier_manufacturer'),
          materiales_rubro: getFieldValueByName('supplier_materials', 'supplier_manufacturer'),
          catalogo_o_lista: getFieldValueByName('supplier_catalog', 'supplier_manufacturer'),
          moq_pedido_minimo: getFieldValueByName('supplier_moq', 'supplier_manufacturer'),
          plazos_de_entrega: getFieldValueByName('supplier_lead_time', 'supplier_manufacturer'),
          ubicacion_pais: getFieldValueByName('supplier_location', 'supplier_manufacturer'),
          marca_blanca_personalizado: getFieldValueByName('supplier_white_label', 'supplier_manufacturer'),
          observaciones_comerciales: getFieldValueByName('supplier_observations', 'supplier_manufacturer')
        },
        compra_mayorista: {
          productos_de_interes: getFieldValueByName('wholesale_products', 'wholesale_purchase'),
          cantidad_estimada: getFieldValueByName('wholesale_quantity', 'wholesale_purchase'),
          frecuencia: getSelectValueByName('wholesale_frequency', 'wholesale_purchase'),
          tipo_de_cliente: getFieldValueByName('wholesale_client_type', 'wholesale_purchase'),
          ubicacion_entrega: getFieldValueByName('wholesale_delivery_location', 'wholesale_purchase'),
          fecha_estimada: getFieldValueByName('wholesale_purchase_date', 'wholesale_purchase'),
          comentarios_adicionales: getFieldValueByName('wholesale_comments', 'wholesale_purchase')
        },
        alianza_comercial: {
          tipo_de_alianza: getFieldValueByName('alliance_type', 'commercial_alliance'),
          propuesta: getFieldValueByName('alliance_proposal', 'commercial_alliance'),
          aporte_de_tu_marca: getFieldValueByName('alliance_value', 'commercial_alliance'),
          expectativas_de_moldarte: getFieldValueByName('alliance_expectations', 'commercial_alliance'),
          links_relevantes: getFieldValueByName('alliance_links', 'commercial_alliance')
        },
        otro: {
          detalle: getFieldValueByName('other_detail', 'other')
        },
        page_url: window.location.href,
        page_title: document.title,
        timestamp: new Date().toISOString(),
        source: 'moldarte-commercial-widget'
      };
    }

    function resetFormState() {
      form.classList.remove('is-submitting');
      if (submitButton) submitButton.disabled = false;
    }

    fieldWraps.forEach(function (fieldWrap) {
      var field = fieldWrap.querySelector('input, select, textarea');
      var helperNode = fieldWrap.querySelector('.moldarte-commercial__helper');

      if (!field) return;

      if (field.hasAttribute('required')) {
        field.setAttribute('data-base-required', 'true');
      }

      if (helperNode && !helperNode.id) {
        helperNode.id = (field.id || field.name || 'moldarte-commercial-field') + '-helper';
      }

      ensureErrorNode(field, fieldWrap);
      clearFieldError(field);

      field.addEventListener('blur', function () {
        validateField(field);
      });

      field.addEventListener('input', function () {
        if (fieldWrap.classList.contains('has-error')) {
          validateField(field);
        }
      });

      field.addEventListener('change', function () {
        if (fieldWrap.classList.contains('has-error') || field.tagName.toLowerCase() === 'select') {
          validateField(field);
        }
      });
    });

    if (typeField) {
      typeField.addEventListener('change', function () {
        clearStatus();
        togglePanels();
      });
    }

    togglePanels();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearStatus();

      if (form.classList.contains('is-submitting')) return;

      if (!validateForm()) {
        setStatus('error', 'Revisá los campos marcados para que podamos recibir bien tu consulta comercial.');

        var firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) {
          firstInvalid.focus({ preventScroll: true });
          scrollIntoViewIfNeeded(firstInvalid);
        }
        return;
      }

      if (!N8N_WEBHOOK_URL || N8N_WEBHOOK_URL.indexOf('YOUR-N8N-WEBHOOK-URL-HERE') !== -1) {
        setStatus('error', 'Antes de publicar el formulario necesitás reemplazar la URL del webhook de n8n.');
        return;
      }

      form.classList.add('is-submitting');
      if (submitButton) submitButton.disabled = true;
      setStatus('success', 'Enviando tu consulta…');

      window.fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(buildPayload())
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Webhook response was not successful');
          }

          setStatus('success', '¡Gracias! Recibimos tu consulta comercial y te vamos a responder apenas la revisemos.');
          form.reset();
          togglePanels();
          fields.forEach(clearFieldError);
        })
        .catch(function () {
          setStatus('error', 'No pudimos enviar el formulario en este momento. Probá de nuevo en unos minutos.');
        })
        .finally(function () {
          resetFormState();
        });
    });

    container.dataset.moldarteCommercialInitialized = 'true';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var widgets = document.querySelectorAll('[data-moldarte-commercial-widget]');
    Array.prototype.forEach.call(widgets, initMoldarteCommercialWidget);
  });
})();
